import { render, staticRenderFns } from "./TransfersDisclosures.vue?vue&type=template&id=30c50f32&"
import script from "./TransfersDisclosures.vue?vue&type=script&lang=js&"
export * from "./TransfersDisclosures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports